
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.75.5a.76.76 0 01.75.75v1.5a.74.74 0 01-.75.75h-1.5a.722.722 0 01-.75-.75v-1.5A.74.74 0 011.25.5h1.5zM15 1c.531 0 1 .469 1 1 0 .563-.469 1-1 1H6c-.563 0-1-.438-1-1 0-.531.438-1 1-1h9zm0 5c.531 0 1 .469 1 1 0 .563-.469 1-1 1H6c-.563 0-1-.438-1-1 0-.531.438-1 1-1h9zm0 5c.531 0 1 .469 1 1 0 .563-.469 1-1 1H6c-.563 0-1-.438-1-1 0-.531.438-1 1-1h9zM.5 6.25a.74.74 0 01.75-.75h1.5a.76.76 0 01.75.75v1.5a.74.74 0 01-.75.75h-1.5a.722.722 0 01-.75-.75v-1.5zm2.25 4.25a.76.76 0 01.75.75v1.5a.74.74 0 01-.75.75h-1.5a.722.722 0 01-.75-.75v-1.5a.74.74 0 01.75-.75h1.5z","fill":"#fff"}})])
          )
        }
      }
    